// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.5
//   protoc               v7.34.1
// source: pronunciations.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";

export const protobufPackage = "pronunciations";

export interface TTSRule {
  id: string;
  regex: string;
  replacement: string;
  caseSensitive: boolean;
  createdAt: string;
  createdBy: string;
  updatedAt: string;
  updatedBy: string;
  languageCode: string;
  description: string;
  position: number;
  name: string;
}

export interface Pronunciations {
  pronunciations: TTSRule[];
}

/** commands */
export interface PronunciationsCreatePronunciation {
  id: string;
  regex: string;
  replacement: string;
  caseSensitive: boolean;
  languageCode: string;
  description: string;
  position: number;
  name: string;
}

export interface PronunciationsUpdatePronunciation {
  id?: string | undefined;
  regex?: string | undefined;
  replacement?: string | undefined;
  caseSensitive?: boolean | undefined;
  languageCode?: string | undefined;
  description?: string | undefined;
  position?: number | undefined;
  name?: string | undefined;
}

export interface PronunciationsDeletePronunciation {
  id: string;
}

export interface PronunciationsReorderPronunciations {
  newPositions: PronunciationPositionUpdate[];
}

export interface PronunciationPositionUpdate {
  id: string;
  position: number;
}

function createBaseTTSRule(): TTSRule {
  return {
    id: "",
    regex: "",
    replacement: "",
    caseSensitive: false,
    createdAt: "",
    createdBy: "",
    updatedAt: "",
    updatedBy: "",
    languageCode: "",
    description: "",
    position: 0,
    name: "",
  };
}

export const TTSRule: MessageFns<TTSRule> = {
  encode(message: TTSRule, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.regex !== "") {
      writer.uint32(18).string(message.regex);
    }
    if (message.replacement !== "") {
      writer.uint32(26).string(message.replacement);
    }
    if (message.caseSensitive !== false) {
      writer.uint32(32).bool(message.caseSensitive);
    }
    if (message.createdAt !== "") {
      writer.uint32(42).string(message.createdAt);
    }
    if (message.createdBy !== "") {
      writer.uint32(50).string(message.createdBy);
    }
    if (message.updatedAt !== "") {
      writer.uint32(58).string(message.updatedAt);
    }
    if (message.updatedBy !== "") {
      writer.uint32(66).string(message.updatedBy);
    }
    if (message.languageCode !== "") {
      writer.uint32(74).string(message.languageCode);
    }
    if (message.description !== "") {
      writer.uint32(82).string(message.description);
    }
    if (message.position !== 0) {
      writer.uint32(88).int32(message.position);
    }
    if (message.name !== "") {
      writer.uint32(98).string(message.name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TTSRule {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTTSRule();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.regex = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.replacement = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.caseSensitive = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.createdAt = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.updatedAt = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.languageCode = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.position = reader.int32();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TTSRule {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      regex: isSet(object.regex) ? globalThis.String(object.regex) : "",
      replacement: isSet(object.replacement) ? globalThis.String(object.replacement) : "",
      caseSensitive: isSet(object.caseSensitive)
        ? globalThis.Boolean(object.caseSensitive)
        : isSet(object.case_sensitive)
        ? globalThis.Boolean(object.case_sensitive)
        : false,
      createdAt: isSet(object.createdAt)
        ? globalThis.String(object.createdAt)
        : isSet(object.created_at)
        ? globalThis.String(object.created_at)
        : "",
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? globalThis.String(object.updatedAt)
        : isSet(object.updated_at)
        ? globalThis.String(object.updated_at)
        : "",
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : "",
      languageCode: isSet(object.languageCode)
        ? globalThis.String(object.languageCode)
        : isSet(object.language_code)
        ? globalThis.String(object.language_code)
        : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      position: isSet(object.position) ? globalThis.Number(object.position) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
    };
  },

  toJSON(message: TTSRule): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.regex !== "") {
      obj.regex = message.regex;
    }
    if (message.replacement !== "") {
      obj.replacement = message.replacement;
    }
    if (message.caseSensitive !== false) {
      obj.caseSensitive = message.caseSensitive;
    }
    if (message.createdAt !== "") {
      obj.createdAt = message.createdAt;
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.updatedAt !== "") {
      obj.updatedAt = message.updatedAt;
    }
    if (message.updatedBy !== "") {
      obj.updatedBy = message.updatedBy;
    }
    if (message.languageCode !== "") {
      obj.languageCode = message.languageCode;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.position !== 0) {
      obj.position = Math.round(message.position);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    return obj;
  },

  create(base?: DeepPartial<TTSRule>): TTSRule {
    return TTSRule.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TTSRule>): TTSRule {
    const message = createBaseTTSRule();
    message.id = object.id ?? "";
    message.regex = object.regex ?? "";
    message.replacement = object.replacement ?? "";
    message.caseSensitive = object.caseSensitive ?? false;
    message.createdAt = object.createdAt ?? "";
    message.createdBy = object.createdBy ?? "";
    message.updatedAt = object.updatedAt ?? "";
    message.updatedBy = object.updatedBy ?? "";
    message.languageCode = object.languageCode ?? "";
    message.description = object.description ?? "";
    message.position = object.position ?? 0;
    message.name = object.name ?? "";
    return message;
  },
};

function createBasePronunciations(): Pronunciations {
  return { pronunciations: [] };
}

export const Pronunciations: MessageFns<Pronunciations> = {
  encode(message: Pronunciations, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.pronunciations) {
      TTSRule.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Pronunciations {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePronunciations();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pronunciations.push(TTSRule.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Pronunciations {
    return {
      pronunciations: globalThis.Array.isArray(object?.pronunciations)
        ? object.pronunciations.map((e: any) => TTSRule.fromJSON(e))
        : [],
    };
  },

  toJSON(message: Pronunciations): unknown {
    const obj: any = {};
    if (message.pronunciations?.length) {
      obj.pronunciations = message.pronunciations.map((e) => TTSRule.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<Pronunciations>): Pronunciations {
    return Pronunciations.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Pronunciations>): Pronunciations {
    const message = createBasePronunciations();
    message.pronunciations = object.pronunciations?.map((e) => TTSRule.fromPartial(e)) || [];
    return message;
  },
};

function createBasePronunciationsCreatePronunciation(): PronunciationsCreatePronunciation {
  return {
    id: "",
    regex: "",
    replacement: "",
    caseSensitive: false,
    languageCode: "",
    description: "",
    position: 0,
    name: "",
  };
}

export const PronunciationsCreatePronunciation: MessageFns<PronunciationsCreatePronunciation> = {
  encode(message: PronunciationsCreatePronunciation, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.regex !== "") {
      writer.uint32(18).string(message.regex);
    }
    if (message.replacement !== "") {
      writer.uint32(26).string(message.replacement);
    }
    if (message.caseSensitive !== false) {
      writer.uint32(32).bool(message.caseSensitive);
    }
    if (message.languageCode !== "") {
      writer.uint32(42).string(message.languageCode);
    }
    if (message.description !== "") {
      writer.uint32(50).string(message.description);
    }
    if (message.position !== 0) {
      writer.uint32(56).int32(message.position);
    }
    if (message.name !== "") {
      writer.uint32(66).string(message.name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PronunciationsCreatePronunciation {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePronunciationsCreatePronunciation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.regex = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.replacement = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.caseSensitive = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.languageCode = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.position = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PronunciationsCreatePronunciation {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      regex: isSet(object.regex) ? globalThis.String(object.regex) : "",
      replacement: isSet(object.replacement) ? globalThis.String(object.replacement) : "",
      caseSensitive: isSet(object.caseSensitive)
        ? globalThis.Boolean(object.caseSensitive)
        : isSet(object.case_sensitive)
        ? globalThis.Boolean(object.case_sensitive)
        : false,
      languageCode: isSet(object.languageCode)
        ? globalThis.String(object.languageCode)
        : isSet(object.language_code)
        ? globalThis.String(object.language_code)
        : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      position: isSet(object.position) ? globalThis.Number(object.position) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
    };
  },

  toJSON(message: PronunciationsCreatePronunciation): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.regex !== "") {
      obj.regex = message.regex;
    }
    if (message.replacement !== "") {
      obj.replacement = message.replacement;
    }
    if (message.caseSensitive !== false) {
      obj.caseSensitive = message.caseSensitive;
    }
    if (message.languageCode !== "") {
      obj.languageCode = message.languageCode;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.position !== 0) {
      obj.position = Math.round(message.position);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    return obj;
  },

  create(base?: DeepPartial<PronunciationsCreatePronunciation>): PronunciationsCreatePronunciation {
    return PronunciationsCreatePronunciation.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PronunciationsCreatePronunciation>): PronunciationsCreatePronunciation {
    const message = createBasePronunciationsCreatePronunciation();
    message.id = object.id ?? "";
    message.regex = object.regex ?? "";
    message.replacement = object.replacement ?? "";
    message.caseSensitive = object.caseSensitive ?? false;
    message.languageCode = object.languageCode ?? "";
    message.description = object.description ?? "";
    message.position = object.position ?? 0;
    message.name = object.name ?? "";
    return message;
  },
};

function createBasePronunciationsUpdatePronunciation(): PronunciationsUpdatePronunciation {
  return {
    id: undefined,
    regex: undefined,
    replacement: undefined,
    caseSensitive: undefined,
    languageCode: undefined,
    description: undefined,
    position: undefined,
    name: undefined,
  };
}

export const PronunciationsUpdatePronunciation: MessageFns<PronunciationsUpdatePronunciation> = {
  encode(message: PronunciationsUpdatePronunciation, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      writer.uint32(10).string(message.id);
    }
    if (message.regex !== undefined) {
      writer.uint32(18).string(message.regex);
    }
    if (message.replacement !== undefined) {
      writer.uint32(26).string(message.replacement);
    }
    if (message.caseSensitive !== undefined) {
      writer.uint32(32).bool(message.caseSensitive);
    }
    if (message.languageCode !== undefined) {
      writer.uint32(42).string(message.languageCode);
    }
    if (message.description !== undefined) {
      writer.uint32(50).string(message.description);
    }
    if (message.position !== undefined) {
      writer.uint32(56).int32(message.position);
    }
    if (message.name !== undefined) {
      writer.uint32(66).string(message.name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PronunciationsUpdatePronunciation {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePronunciationsUpdatePronunciation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.regex = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.replacement = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.caseSensitive = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.languageCode = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.position = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PronunciationsUpdatePronunciation {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : undefined,
      regex: isSet(object.regex) ? globalThis.String(object.regex) : undefined,
      replacement: isSet(object.replacement) ? globalThis.String(object.replacement) : undefined,
      caseSensitive: isSet(object.caseSensitive)
        ? globalThis.Boolean(object.caseSensitive)
        : isSet(object.case_sensitive)
        ? globalThis.Boolean(object.case_sensitive)
        : undefined,
      languageCode: isSet(object.languageCode)
        ? globalThis.String(object.languageCode)
        : isSet(object.language_code)
        ? globalThis.String(object.language_code)
        : undefined,
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      position: isSet(object.position) ? globalThis.Number(object.position) : undefined,
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
    };
  },

  toJSON(message: PronunciationsUpdatePronunciation): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = message.id;
    }
    if (message.regex !== undefined) {
      obj.regex = message.regex;
    }
    if (message.replacement !== undefined) {
      obj.replacement = message.replacement;
    }
    if (message.caseSensitive !== undefined) {
      obj.caseSensitive = message.caseSensitive;
    }
    if (message.languageCode !== undefined) {
      obj.languageCode = message.languageCode;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.position !== undefined) {
      obj.position = Math.round(message.position);
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    return obj;
  },

  create(base?: DeepPartial<PronunciationsUpdatePronunciation>): PronunciationsUpdatePronunciation {
    return PronunciationsUpdatePronunciation.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PronunciationsUpdatePronunciation>): PronunciationsUpdatePronunciation {
    const message = createBasePronunciationsUpdatePronunciation();
    message.id = object.id ?? undefined;
    message.regex = object.regex ?? undefined;
    message.replacement = object.replacement ?? undefined;
    message.caseSensitive = object.caseSensitive ?? undefined;
    message.languageCode = object.languageCode ?? undefined;
    message.description = object.description ?? undefined;
    message.position = object.position ?? undefined;
    message.name = object.name ?? undefined;
    return message;
  },
};

function createBasePronunciationsDeletePronunciation(): PronunciationsDeletePronunciation {
  return { id: "" };
}

export const PronunciationsDeletePronunciation: MessageFns<PronunciationsDeletePronunciation> = {
  encode(message: PronunciationsDeletePronunciation, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PronunciationsDeletePronunciation {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePronunciationsDeletePronunciation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PronunciationsDeletePronunciation {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: PronunciationsDeletePronunciation): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<PronunciationsDeletePronunciation>): PronunciationsDeletePronunciation {
    return PronunciationsDeletePronunciation.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PronunciationsDeletePronunciation>): PronunciationsDeletePronunciation {
    const message = createBasePronunciationsDeletePronunciation();
    message.id = object.id ?? "";
    return message;
  },
};

function createBasePronunciationsReorderPronunciations(): PronunciationsReorderPronunciations {
  return { newPositions: [] };
}

export const PronunciationsReorderPronunciations: MessageFns<PronunciationsReorderPronunciations> = {
  encode(message: PronunciationsReorderPronunciations, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.newPositions) {
      PronunciationPositionUpdate.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PronunciationsReorderPronunciations {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePronunciationsReorderPronunciations();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.newPositions.push(PronunciationPositionUpdate.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PronunciationsReorderPronunciations {
    return {
      newPositions: globalThis.Array.isArray(object?.newPositions)
        ? object.newPositions.map((e: any) => PronunciationPositionUpdate.fromJSON(e))
        : globalThis.Array.isArray(object?.new_positions)
        ? object.new_positions.map((e: any) => PronunciationPositionUpdate.fromJSON(e))
        : [],
    };
  },

  toJSON(message: PronunciationsReorderPronunciations): unknown {
    const obj: any = {};
    if (message.newPositions?.length) {
      obj.newPositions = message.newPositions.map((e) => PronunciationPositionUpdate.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<PronunciationsReorderPronunciations>): PronunciationsReorderPronunciations {
    return PronunciationsReorderPronunciations.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PronunciationsReorderPronunciations>): PronunciationsReorderPronunciations {
    const message = createBasePronunciationsReorderPronunciations();
    message.newPositions = object.newPositions?.map((e) => PronunciationPositionUpdate.fromPartial(e)) || [];
    return message;
  },
};

function createBasePronunciationPositionUpdate(): PronunciationPositionUpdate {
  return { id: "", position: 0 };
}

export const PronunciationPositionUpdate: MessageFns<PronunciationPositionUpdate> = {
  encode(message: PronunciationPositionUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.position !== 0) {
      writer.uint32(16).int32(message.position);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PronunciationPositionUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePronunciationPositionUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.position = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PronunciationPositionUpdate {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      position: isSet(object.position) ? globalThis.Number(object.position) : 0,
    };
  },

  toJSON(message: PronunciationPositionUpdate): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.position !== 0) {
      obj.position = Math.round(message.position);
    }
    return obj;
  },

  create(base?: DeepPartial<PronunciationPositionUpdate>): PronunciationPositionUpdate {
    return PronunciationPositionUpdate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PronunciationPositionUpdate>): PronunciationPositionUpdate {
    const message = createBasePronunciationPositionUpdate();
    message.id = object.id ?? "";
    message.position = object.position ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
